export const ROLES = [
  'Admin',
  'SMM Menejer',
  'Dizayner',
  'Montajor',
  'Kopirayter',
  'VFX Mutaxasis',
  'AI Mutaxasis',
];

// null = barcha doskalar ko'rinadi
export const ROLE_BOARDS = {
  'Admin':         null,
  'SMM Menejer':   null,
  'Kopirayter':    null,
  'Dizayner':      null,
  'Montajor':      null,
  'VFX Mutaxasis': null,
  'AI Mutaxasis':  null,
};

export const ROLE_ROUTES = {
  'Admin':         ['/', '/projects', '/analytics', '/calendar', '/contact', '/admin', '/profile'],
  'SMM Menejer':   ['/', '/projects', '/analytics', '/calendar', '/contact', '/profile'],
  'Kopirayter':    ['/analytics', '/calendar', '/contact', '/profile'],
  'Dizayner':      ['/analytics', '/contact', '/profile'],
  'Montajor':      ['/analytics', '/contact', '/profile'],
  'VFX Mutaxasis': ['/analytics', '/contact', '/profile'],
  'AI Mutaxasis':  ['/analytics', '/contact', '/profile'],
};

export const DEFAULT_HOME = {
  'Admin':         '/',
  'SMM Menejer':   '/',
  'Kopirayter':    '/analytics',
  'Dizayner':      '/analytics',
  'Montajor':      '/analytics',
  'VFX Mutaxasis': '/analytics',
  'AI Mutaxasis':  '/analytics',
};

export const canAccess = (role, path) => {
  const allowed = ROLE_ROUTES[role] ?? ROLE_ROUTES['Kopirayter'];
  return allowed.some(r => path === r || (r !== '/' && path.startsWith(`${r}/`)));
};

export const getAllowedBoards = (role) => ROLE_BOARDS[role] ?? null;

export const getDefaultHome = (role) => DEFAULT_HOME[role] ?? '/analytics';
